let NAME = 'versa';
let VERSION = 1;
let STORES = '[{"store":"default","indices":["id"]}]';

// If the db stops working, clear the browser's "site data" in its settings
const exec = function(action_type, store_name, index_number, argument, resolve, reject)
{

	let stores = JSON.parse(sessionStorage.db_stores || STORES);
	let version = sessionStorage.db_version || VERSION;
	let request = indexedDB.open(sessionStorage.db_name || NAME, version);

	request.onblocked = (ev) =>
	{
		alert('Recarregue a página para atualizar a aplicação');
	};

	request.onerror = (ev) =>
	{
		reject(ev.target.error);
	};

	request.onupgradeneeded = (ev) =>
	{
		let db = ev.target.result;
		stores.forEach(entry =>
		{
			if (db.objectStoreNames.contains(entry.store))
				return;
			let store = db.createObjectStore(entry.store, { keyPath: entry.keys[0] });
			entry.keys.forEach((key, index) =>
			{
				let name = `${entry.store}-${index+1}`;
				if (!store.indexNames.contains(name))
					store.createIndex(name, key);
			});
		});
	};

	request.onsuccess = (ev) =>
	{

		let db = ev.target.result;
		if (!db.objectStoreNames.contains(store_name))
		{
			reject(new Error(`Object store "${store_name}" não encontrado. Recarregue a página (F5) para atualizar o banco local.`));
			return;
		}
		let transaction = db.transaction(store_name, /GET|LIST/.test(action_type) ? 'readonly' : 'readwrite');
		let store = transaction.objectStore(store_name);
		let entry = stores.find(entry => entry.store == store_name);
		let index = store.index(`${store_name}-${index_number}`);
		let request;
		let list = [];

		try
		{
			switch (action_type)
			{
				case 'CLEAR':
					store.clear();
					break;
				case 'PUT':
					(Array.isArray(argument) ? argument : []).forEach(entry => store.put(entry));
					resolve();
					break;
				case 'GET':
					request = store.get(argument);
					break;
				case 'DEL':
					request = store.delete(argument);
					break;
				case 'LIST':
					request = (index || store).openCursor(argument);
					break;
			}
		}
		catch (e)
		{
			reject(`${action_type} ${store_name} ${JSON.stringify(argument)} ${e.message}`);
			console.log(e);
		}

		if (request)
		{
			request.onsuccess = (ev) =>
			{
				if (action_type != 'LIST')
				{
					resolve(ev.target.result);
				}
				else
				{
					if (ev.target.result)
					{
						list.push(ev.target.result.value);
						ev.target.result.continue();
					}
					else
					{
						resolve(list);
					}
				}
			};
		}

		db.onerror = (ev) =>
		{
			reject(ev.target.error);
		};

	};

}

const db = {

	define(stores, name, version)
	{
		sessionStorage.db_name = name;
		sessionStorage.db_version = version;
		sessionStorage.db_stores = JSON.stringify(stores);
	},

	init()
	{
		indexedDB.deleteDatabase(NAME);
	},

	clear(store)
	{
		exec('CLEAR', store, 1);
	},

	set(store, array)
	{
		return new Promise(function(resolve, reject)
		{
			exec('PUT', store, 1, array, resolve, reject);
		});
	},

	get(store, key, index = 2)
	{
		const invalid = key == null || (Array.isArray(key) && key.some(v => v == null || (typeof v === 'number' && isNaN(v))));
		if (invalid)
			return Promise.resolve(undefined);
		return new Promise(function(resolve, reject)
		{
			exec('GET', store, index, key, resolve, reject);
		});
	},

	list(store, range, index = 2)
	{
		return new Promise(function(resolve, reject)
		{
			exec('LIST', store, index, range, resolve, reject);
		});
	},

	remove(store, key)
	{
		return new Promise(function(resolve, reject)
		{
			exec('DEL', store, 1, key, resolve, reject);
		});
	}

};

export default db;

